import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { ApiService } from '../service/api.service';
import { ToastrService } from 'ngx-toastr';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-details-grid',
    templateUrl: './details-grid.component.html',
    providers: [DashboardComponent],
    standalone: false
})
export class DetailsGridComponent implements OnInit {
  @Input() public rowData: any;
  @Input() public row: any;
  kendoLoading = false;
  dropdownValues = [
    { text: 'Registered', value: 'Registered' },
    { text: 'OTP Verified', value: 'OTPVerified' },
    { text: 'Password Changed', value: 'PasswordChanged' },
    { text: 'Logged In', value: 'LoggedIn' },
  ];
  status: any;
  selectedCompanyId: any;
  selectedData: any = [];
  public gridData: any;
  constructor(private LoaderService: LoaderService, private api: ApiService,
     private toaster: ToastrService,private router: Router,
    private comp: DashboardComponent) {
  }

  public ngOnInit(): void {
    this.gridData = this.rowData.data.filter((x: any) => x.Id == this.row.Id)
  }

  selectedOption(event: any, dataItem: any) {
    this.status = event.value;
    this.selectedCompanyId = dataItem.Id;
    this.LoaderService.show();
    this.api.updateStatus(this.selectedCompanyId, this.status).subscribe(
      (res: any) => {
        if (res['Success'] === true) {
          if (res['ResponseCode'] === 200) {
            this.LoaderService.hide();
            this.toaster.success('Status Updated Successfully..');
            this.reloadCurrentRoute();
          }
        }
      },
      (_err) => {
        this.LoaderService.hide();
        this.toaster.error('Something went wrong Record not Updated sorry');
      }
    );
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
}
}